import React, { SyntheticEvent, useEffect, useState } from 'react';
import filtersStyles from '../../Filters.module.scss';
import { CloseLight, Action } from 'esa-ui-library';
import { useStore } from '../../../../../common';
import { PropertyType } from 'esa-ui-library/lib/types';
import { FilterDropdown } from '../FilterDropdown/FilterDropdown';
import { getActiveLabels, getFilterValue, getUpdateOptions, selectPreselectedOptions } from '../../Filters.helper';
import { cloneDeep, find } from 'lodash';
import useFilters from '../../../../../common/hooks/useFilters';

const TransactionTypeFilter = (): JSX.Element => {
	const [{ transactionTypes, filters }] = useStore();
	const [filterOptions, setFiltersOptions] = useState<PropertyType[]>([]);
	const { onFilter } = useFilters();

	const onFilterChange = (option: PropertyType) => {
		const updateOptions = getUpdateOptions(option, filterOptions);
		const filterValue = getFilterValue(updateOptions);

		onFilter([{ name: 'transaction_types', value: filterValue }]);
	};

	const onFilterRemove = (e: SyntheticEvent) => {
		e.stopPropagation();

		onFilter([{ name: 'transaction_types', value: '' }]);
	};

	const onSelectAll = () => {
		if (!transactionTypes || !transactionTypes.length) return;
		const allValues = transactionTypes.map((t: PropertyType) => t.value).join(',');
		setFiltersOptions(selectPreselectedOptions(transactionTypes, allValues));
		onFilter([{ name: 'transaction_types', value: allValues }]);
	};

	const getLabelContent = () => {
		const activeLabels = getActiveLabels(filterOptions);
		if (!activeLabels.length) return 'All';

		return (
			<>
				{activeLabels[0]}
				{activeLabels.length > 1 ? `+${activeLabels.length - 1}` : ''}
				<i className={filtersStyles.ClearFilter} onClick={onFilterRemove}>
					<CloseLight size={16} />
				</i>
			</>
		);
	};

	useEffect(() => {
		if (transactionTypes) {
			setFiltersOptions(cloneDeep(transactionTypes));
		}
	}, [transactionTypes]);

	useEffect(() => {
		const filter = find(filters, ['name', 'transaction_types'])?.value || '';
		setFiltersOptions(selectPreselectedOptions(transactionTypes, filter));
	}, [filters]);

	return (
		<Action
			label='Type'
			labelContent={getLabelContent()}
			select
			className={`${filtersStyles.Filter} 
			${getActiveLabels(filterOptions).length ? filtersStyles.Active : ''} `}
			dataId='type-filter'
		>
			<FilterDropdown
				data={filterOptions}
				onChange={onFilterChange}
				isSearchable
				enableSelectAll
				onSelectAll={onSelectAll}
				selectAllLabel='Select All'
			/>
		</Action>
	);
};

export { TransactionTypeFilter };
